import "./info-page.css";
import Typewriter from "typewriter-effect";

function InfoPage() {
  return (
    <div id="infoPage">
      <div className="info-page">
        <div className="flex-container">
          <div className="image-background" data-aos="zoom-out-down">
            {/* If you are changing the image. Update the preloading in index.html and useEffect */}
            <img
              data-aos="zoom-out-down"
              className="image"
              src="https://res.cloudinary.com/ddjpxsrej/image/upload/v1735317860/DSC093612_khmomx.png"
              alt="Mudith Perera"
            />
          </div>

          <div className="name-area" data-aos="fade-up" data-aos-delay="400">
            Mudith Perera
          </div>
          <div className="what-i-area">
            <Typewriter
              options={{
                strings: [
                  "a Software Engineer..",
                  "a Full-Stack Web Developer..",
                  "a Content Creator..",
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 10,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoPage;
